import { Field, RadioGroup, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { hasValue } from 'Lib/Any';
import deepEquals from 'Lib/Object/deepEquals';
import { useSelector } from 'react-redux';

let BsCompactionEquipmentSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const hammerOperation = useSelector(createWorksheetSelector!('Equipment.HammerOperation'));
  const hammerEquipment = useSelector(createWorksheetSelector!('Equipment.Hammer'), deepEquals);
  const hammerImportMismatch = useSelector(createWorksheetSelector!(`Equipment.HammerImportMismatch`));
  const hammerOperationOptions = ['Automatic', 'Manual'].map((e) => ({ label: e, value: e }));

  return (
    <NamePrefixModifier appendNamePrefix="Equipment">
      <ListFieldSection heading="Equipment">
        <WorksheetBalanceFieldSet name="CompactionBalance" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="straight-edge" name="StraightEdge" />
        <FieldSet>
          <Field
            input={<WorksheetEquipmentDropdown />}
            equipmentType="hammer"
            name="Hammer"
            importedAdditionalData={{
              Operation: hammerOperation,
              Mismatch: hammerImportMismatch,
            }}
            importModel={{
              Id: hammerEquipment?.Id,
            }}
          />
          {hasValue(hammerEquipment?.Operation) ? (
            <Field
              input={<TextOutput />}
              name={`HammerOperation`}
              value={hammerOperationOptions.find((o) => o.value === hammerOperation)?.label}
              label="Operation"
            />
          ) : (
            <Field input={<RadioGroup />} name={`HammerOperation`} options={hammerOperationOptions} label="Operation" />
          )}
        </FieldSet>
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="caliper" name="Caliper" />
      </ListFieldSection>
    </NamePrefixModifier>
  );
};

BsCompactionEquipmentSection = withInjectedProps(BsCompactionEquipmentSection);

export { BsCompactionEquipmentSection };
export default BsCompactionEquipmentSection;
